import { useSelector } from 'react-redux';
import { AppState } from '../stores/store';

export function FromStore<T>(selector: (state: AppState) => T): T {
    return useSelector<AppState, T>(selector);
}